<template>
  <div class="group_good" :style="boxStyle">
    <div class="group_good_list">
      <div v-show="groupGoodList.length" class="group_good_content" v-for="(item, idx) in groupGoodList" :key="idx">
          <div class="group_good_img">
              <div class="logo_tag" v-if="item.tagImages">
                  <img mode="aspectFit"  :src="item.tagImages" />
              </div>
              <img class="img"  :src="item.showImg" />
          </div>
          <div class="group_good_info">
              <div class="title">{{item.name}}</div>
              <div class="description"></div>
              <div class="orgin_price">
                  <span class="orgin_price_txt" v-if="showOriginalPrice">原价：¥{{item.originalPrice}}</span>
                  <span class="has_group" v-if="item.showGroupNum && (item.useAmount > 0 || item.initUseAmount > 0)">已成团{{item.useAmount + (item.initUseAmount || 0)}}件</span>
              </div>
              <div class="group_price">
                    <div v-for="(groupItem, index) in item.groupBuyingDetail" :key="index" :class="['group_buy', index >= 1?'group_buy1':'']">
                        <div class="two_price">
                            <span class="symbol red">¥</span>
                            <span class="price red">{{groupItem.price > groupItem.ownerPrice ? groupItem.ownerPrice : groupItem.price}}</span>
                        </div>
                        <div class="price_txt">{{groupItem.memNum}}人团购价</div>
                    </div>
              </div>
              <div class="group_btn group_btn1" v-if="item.amount <= item.useAmount">已售罄</div>
              <div class="group_btn public_bg" v-else-if="item.notStart">等待开售</div>
              <div class="group_btn public_bg" v-else>立即开团</div>
          </div>
      </div>
      <div v-show="!groupGoodList.length" class="defaultImg"></div>
  </div>
  </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'groupGood',
  mixins: [mixins],
  props: {},
  components: {},
  data() {
    return {
      groupGoodList:[], // 团购商品
      pattern: {},
    }
  },
  computed: {
    showOriginalPrice() {
        return true;
    },
    boxStyle(){
      return {
        "margin-left": (this.pattern.margin || 0) + 'px',
        "margin-right": (this.pattern.margin || 0) + 'px',
      }
    },
  },
  watch: {
  },
  methods: {
    groupGoodData(data) {
      this.groupGoodList = data.map(element => {
          const { startTime } = element;
          if (startTime > (new Date().getTime())) {
              element.notStart = true;
          }
          let images = element.images.split(','); 
          element.showImg = this.getPicture('mall', {
              file: images[0],
              type: 'mall',
              size: 's',
              options: {
                  parentShopId: this.tenantId
              }
          });
          if (element.tagImages) {
              element.tagImages = this.getPicture('tagImages', {
                  file: element.tagImages
              });
          }
          if(element.groupbuyingdetail){
            let groupBuyingDetail = JSON.parse(element.groupbuyingdetail);
            element.groupBuyingDetail = [groupBuyingDetail[0]]
          }
          return element
      })
    },
    async init() {
        let detailData = await this._filter(this.itemData)
        this.pattern = detailData.pattern || {}
        console.log("groupGood----------detailData");
        console.log(detailData);
        this.groupGoodData(detailData.groupGoodArr)
    },
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss">
    .group_good {
        // width: 269px;
        .red{
            color: #eb637a;
        }
        .group_good_list {
            position: relative;
            background-color: #fff;
            margin-bottom: 1px;
            .group_good_content {
                padding: 10px;
                position: relative;
                .group_good_img {
                    display: inline-block;
                    width: 89px;
                    height: 89px;
                    overflow: hidden;
                    // border: 1rpx solid #DBDBDB;
                    margin-right: 10px;
                    margin-left: 1px;
                    border-radius: 6px;
                    position: relative;
                    .logo_tag{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 40px;
                        height: 40px;
                        z-index: 3;
                    }
                }
                .group_good_info {
                    display: inline-block;
                    vertical-align: top;
                    .title {
                        width: 139px;
                        font-size: 14px;
                        color: #333;
                        font-weight: 600;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                    .description {
                        width: 139px;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        font-size: 10px;
                        color: #999;
                        margin-top: 3px;
                        height: 10px;
                    }
                    .orgin_price {
                        margin-top: 3px;
                        .orgin_price_txt {
                            text-decoration:line-through;
                            font-size: 10px;
                            color: #C8C8C8;
                            margin-top: 14px;
                        }
                        .has_group {
                            float: right;
                            color: #999;
                            font-size: 11px;
                        }
                    }
                    .group_price {
                        .group_buy {
                            display: inline-block;
                            font-size: 11px;
                            color: #333;
                            margin-top: 2px;
                            margin-right: 10px;
                            .symbol {
                                font-size: 11px;
                            }
                            .price {
                                font-size: 16px;
                                font-weight: bold;
                            }
                        }
                        .group_buy1 {
                            margin-right: 0;
                            border-left: 1px solid #D8D8D8;
                            padding-left: 10px;
                        }
                    }
                    .group_btn {
                        position: absolute;
                        right: 10px;
                        bottom: 12px;
                        color: #fff;
                        font-size: 12px;
                        padding: 4px 10px;
                        border-radius: 28px;
                        text-align: center;
                        background-color: #eb637a;
                        &.group_btn1 {
                            background-color: #A1A1A1;
                        }
                    }
                }
            }
            .defaultImg{
                width: 100%;
                height: 0;
                padding-top: 48%;
                background-image: url("../image/groupGood.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
            }
        }
    }
</style>
